import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.section`
    display: block;
    width: 100%;
    background-color: ${COLORS.GRAY_DARK};
    padding: 64px 0 32px 0;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 60px 0 28px 0;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 56px 0 40px 0;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 30px 0 25px 0;
    }
`;

export const HeadTitle = styled.h2`
    ${FONTS.H2};
    color: ${COLORS.white};
    margin-bottom: 32px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H3};
        margin-bottom: 24px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 8px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H2};
    }

`;

export const SBaseButton = styled(BaseButton)`
    margin: 32px auto 0 auto;
    width: 186px;
`;
